import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { AuthProvider, RequireAuth } from "./AuthProvider";
import { GqlProvider } from "./GqlProvider";
import { ResetPassword } from "./pages/ResetPassword";
import { Organizations } from "./pages/Organizations";
import { Organization } from "./pages/Organization";
import { User } from "./pages/User";
import { Admin } from "./pages/Admin";
import { LedgerProvider } from "./components/Ledger";
import { Distribution } from "./pages/Distribution";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
});

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const router = sentryCreateBrowserRouter([
  {
    path: "/",
    element: (
      <RequireAuth>
        <Dashboard />
      </RequireAuth>
    ),
  },
  {
    path: "/reset-password/:token",
    element: <ResetPassword />,
  },
  {
    path: "/organizations",
    element: (
      <RequireAuth>
        <Organizations />
      </RequireAuth>
    ),
  },
  {
    path: "/organizations/:id",
    element: (
      <RequireAuth>
        <Organization />
      </RequireAuth>
    ),
  },
  {
    path: "/user/:id",
    element: (
      <RequireAuth>
        <User />
      </RequireAuth>
    ),
  },
  {
    path: "/distribution/:id",
    element: (
      <RequireAuth>
        <Distribution />
      </RequireAuth>
    ),
  },
  {
    path: "/admin",
    element: (
      <RequireAuth>
        <Admin />
      </RequireAuth>
    ),
  },
  {
    path: "/login",
    element: <Login />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <GqlProvider>
        <LedgerProvider>
          <RouterProvider router={router} />
        </LedgerProvider>
      </GqlProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
